import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import {
  fetchAllCarriers,
  addCarrier,
  removeCarrier,
  updateCarrier,
} from '../actions/carrier.action'
import { CarrierList, UpdateCarrierThunkParams } from '@dataTypes/index'

type CarrierState = {
  data: CarrierList[] | null
  loading: boolean
  error: null
}

const initialState: CarrierState = {
  data: null,
  loading: false,
  error: null,
}

const carriersSlice = createSlice({
  name: 'carriers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchAllCarriers.fulfilled,
      (state, action: PayloadAction<CarrierList[]>) => {
        state.data = action.payload
        state.loading = false
      },
    )
    builder.addCase(fetchAllCarriers.pending, (state) => {
      state.loading = true
    })
    builder.addCase(fetchAllCarriers.rejected, (state) => {
      state.error = null
      state.loading = false
    })

    builder.addCase(
      addCarrier.fulfilled,
      (state, action: PayloadAction<CarrierList>) => {
        state.data = state.data
          ? [...state.data, action.payload]
          : [action.payload]
        state.loading = false
      },
    )
    builder.addCase(addCarrier.pending, (state) => {
      state.loading = true
    })
    builder.addCase(addCarrier.rejected, (state) => {
      state.error = null
      state.loading = false
    })

    builder.addCase(
      updateCarrier.fulfilled,
      (state, action: PayloadAction<UpdateCarrierThunkParams>) => {
        const { id, body: updatedCarrier } = action.payload
        if (!state.data) return
        const index = state.data.findIndex((item) => item.id === id)
        if (index !== -1) {
          state.data[index] = { ...state.data[index], ...updatedCarrier }
        }
        state.loading = false
      },
    )
    builder.addCase(updateCarrier.pending, (state) => {
      state.loading = true
    })
    builder.addCase(updateCarrier.rejected, (state) => {
      state.error = null
      state.loading = false
    })

    builder.addCase(removeCarrier.fulfilled, (state, action) => {
      const id = action.payload
      if (!state.data) return
      const index = state.data.findIndex((item) => item.id === id)
      if (index !== -1) {
        state.data && state.data.splice(index, 1)
      }
      state.loading = false
    })
    builder.addCase(removeCarrier.pending, (state) => {
      state.loading = true
    })
    builder.addCase(removeCarrier.rejected, (state) => {
      state.error = null
      state.loading = false
    })
  },
})

export default carriersSlice.reducer
